import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';

import { i18n } from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import Clipboard from 'v-clipboard';
import 'bootstrap';
import VuejsDialog from 'vuejs-dialog';
import VCalendar from 'v-calendar';
import VDatePicker from 'v-calendar';
import { ToggleButton } from 'vue-js-toggle-button';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueCookies from 'vue-cookies';
import TextareaAutosize from 'vue-textarea-autosize';

import '@/styles/custom-bootstrap.scss';
import '@/styles/style.scss';

import {
  faThumbsUp,
  faTrashAlt,
  faEdit,
  faUserEdit,
  faKeyboard,
  faCalendarDay,
  faCalendarCheck,
  faClock,
  faUser,
  faUserCog,
  faBars,
  faCheck,
  faTimes,
  faPlusCircle,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faQuestion,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faLink,
  faUsers,
  faMinusCircle,
  faShareAltSquare,
  faShareAlt,
  faSave,
  faUserPlus,
  faAt,
  faAddressCard,
  faAddressBook,
  faPlus,
  faFileExcel,
  faCog,
  faAngleLeft,
  faAngleRight,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faQuestionCircle,
  faMinus,
  faInfoCircle,
  faTimesCircle,
  faPencil,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faUserFriends,
  faSquare,
  faCheckSquare,
  faCircle,
  faDotCircle,
  faSpinner,
  faEye,
  faEyeSlash,
  faBallotCheck,
  faGlobe,
  faAngleUp,
  faAngleDown,
  faTable,
  faCommentDots,
  faSortAlphaDown,
  faSortNumericDown,
} from '@fortawesome/pro-light-svg-icons';

import {
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faUserEdit as fasUserEdit,
  faUserFriends as fasUserFriends,
  faTimes as fasTimes,
  faCheck as fasCheck,
  faCircle as fasCircle,
  faInfoCircle as fasInfoCircle,
  faDotCircle as fasDotCircle,
  faUser as fasUser,
  faPencil as fasPencil,
  faPlusCircle as fasPlusCircle,
  faCopy as fasCopy,
  faUserCircle as fasUserCircle,
  faArrowAltRight as fasArrowAltRight,
  faArrowAltLeft as fasArrowAltLeft,
  faFileExport as fasFileExport,
  faAnalytics as fasAnalytics,
  faQuestion as fasQuestion,
  faInfo as fasInfo,
  faEllipsisH as fasEllipsisH,
  faLock as fasLock,
  faLockOpen as fasLockOpen,
  faAngleUp as fasAngleUp,
  faAngleDown as fasAngleDown,
  faList as fasList,
  faCommentDots as fasCommentDots,
  faCalendarCheck as fasCalendarCheck,
  faArchive as fasArchive,
  faUndo as fasUndo,
  faTrophy as fasTrophy

} from '@fortawesome/pro-solid-svg-icons';

import {
  faCommentDots as farCommentDots,
  faCalendarCheck as farCalendarCheck,
  faPlusCircle as farPlusCircle,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faThumbsUp,
  faTrashAlt,
  faEdit,
  faUserEdit,
  faKeyboard,
  faCalendarDay,
  faCalendarCheck,
  faClock,
  faUser,
  faUserCog,
  faBars,
  faCheck,
  faTimes,
  faPlusCircle,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faQuestion,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopeOpenText,
  faLink,
  faUsers,
  faMinusCircle,
  faShareAltSquare,
  faShareAlt,
  faSave,
  faUserPlus,
  faAt,
  faAddressCard,
  faAddressBook,
  faPlus,
  faFileExcel,
  faCog,
  faAngleLeft,
  faAngleRight,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faQuestionCircle,
  faMinus,
  faInfoCircle,
  fasInfoCircle,
  faTimesCircle,
  faPencil,
  fasChevronLeft,

  fasChevronRight,
  fasChevronUp,
  fasChevronDown,
  fasUserEdit,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faUserFriends,
  faTable,
  fasUserFriends,
  fasTimes,
  fasCheck,
  faSquare,
  faCheckSquare,
  faCircle,
  faDotCircle,
  fasCircle,
  fasDotCircle,
  faSpinner,
  faEye,
  faEyeSlash,
  faCommentDots,
  faSortAlphaDown,
  faSortNumericDown,
  fasUser,
  fasPencil,
  fasPlusCircle,
  fasCopy,
  faBallotCheck,
  fasUserCircle,
  fasArrowAltRight,
  fasArrowAltLeft,
  fasFileExport,
  fasAnalytics,
  fasQuestion,
  fasInfo,
  fasEllipsisH,
  fasLock,
  fasLockOpen,
  faGlobe,
  faAngleUp,
  faAngleDown,
  fasAngleUp,
  fasAngleDown,
  fasList,
  fasCommentDots,
  fasCalendarCheck,
  farCommentDots,
  farCalendarCheck,
  fasArchive,
  farPlusCircle,
  fasUndo,
  fasTrophy
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ToggleButton', ToggleButton);

//Vue.prototype.$http = Axios;
// const token = localStorage.getItem('token');
// if (token) {
//   Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
// }

Vue.use(FlagIcon);
Vue.use(Clipboard);
Vue.use(VuejsDialog);
Vue.use(VCalendar, {
  componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VDatePicker, {
  componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VueCookies);

Vue.use(TextareaAutosize);

import vueScrollto from 'vue-scrollto';
Vue.use(vueScrollto, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

// if (process.env.NODE_ENV != 'development') {
//   console.log = function () {};
// }

// timemachine configuration
const regsressionTesting = false;
// async function activayeTimemachine() {
//   await import('@/shared/timemachine');
// }

if (regsressionTesting) {
  // (async () => await activayeTimemachine())();
  var tk = require('timekeeper');
  var time = new Date('2022-02-02T03:24:00');
  tk.freeze(time);
}

//  import timemachine from 'timemachine';
//  timemachine.config({
//    dateString: 'July 8, 2021 13:12:59',
//  });

Array.prototype.deleteObjectById = function (deleteId) {
  let index = this.findIndex((item) => item.id === deleteId);
  if (index >= 0) {
    this.splice(index, 1);
  }
};

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'vue-search-select/dist/VueSearchSelect.css';

// for the babel configuration

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'core-js';

import { HTTP } from '@/shared/http';

//const buildTimestamp = document.documentElement.dataset.buildTimestampUtc;


Vue.use(PerfectScrollbar);

// console.log("process.env.NODE_ENV:", process.env.NODE_ENV);

Vue.config.productionTip = false;

// set the language accroding to the browser
let currentLocale = navigator.language.substring(0, 2);
i18n.locale = currentLocale;

// set the language according to the wordpress settings
const url = process.env.VUE_APP_PUBLIC_HOME + '/locale.php';

console.error("url for wordpress locale:", url);

const localStorageUser = localStorage.getItem('user');
const localLocale = localStorage.getItem('local-locale');
HTTP.get(url).then((response) => {
  console.log('Check WP locale:', response.data, localStorageUser);
  // no authenticated user or local locale -> take the language from WP
  if (!localStorageUser && !localLocale) {
    currentLocale = response.data;
    console.log('Cookie Locale:', currentLocale);
    if (currentLocale != '') {
      i18n.locale = currentLocale;
      console.log('Change WP  locale to:', currentLocale);
    }
  }
});

// if the user is logged in -> use his language preference
if (localStorageUser) {
  const user = JSON.parse(localStorageUser);
  const currentLocale = user.locale;
  console.log('Change user locale to:', currentLocale);
  i18n.locale = currentLocale;
} else {
  // get the locale of the anonymous user
  if (localLocale) {
    i18n.locale = localLocale;
    console.log('Change local locale to:', localLocale);
  }
}

console.log('Current locale:', i18n.locale);

// import all global components (placed in /components/index.js)
import '@/components';

HTTP.get('/sanctum/csrf-cookie').then(() => {
  store.state.csrfInitialized = true;
  new Vue({
    router,
    i18n,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
